import React from 'react';

export interface AmpelDataItem {
  Ampel: string;
  Ampel_alt_text: string;
  bestand: string;
  ean: string;
  Lieferant: string;
  lz: string;
  erfuellungsrate: string;
}

interface AmpelProps {
  items?: AmpelDataItem[];
  i18n?: (key: string) => string;
}

export default class Ampel extends React.Component<AmpelProps> {
  render() {
    return (
      <div className="ampelDiv">
        <div className="header">
          <div className="cells">Lieferant</div>
          <div className="cells">Status</div>
          <div className="cells"></div>
        </div>
        {this.props.items?.map((item, index) => {
          let rowClassName = 'row';
          if (index % 2 == 0) rowClassName = rowClassName + ' mod2';

          return (
            <div className={rowClassName} key={'ampel_' + index}>
              <div className="cells">{item.Lieferant}</div>
              {/* 
              <div className="cells">
                <div
                  className="symbol"
                  style={{ backgroundColor: item.Ampel }}
                  title={item.Ampel_alt_text}
                />
              </div>
              */}
              <div className="cells">
                {+item.bestand > 0 ? (
                  <>
                    {/* 
                    Lieferzeit: ca. {+item.lz < 2 ? +item.lz + 3 : +item.lz}{' '}
                    Werktage
                    */}
                    verfügbar
                  </>
                ) : (
                  <>nicht verfügbar</>
                )}
              </div>
            </div>
          );
        })}
      </div>
    );
  }
}
